import React from 'react'
import PropTypes from 'prop-types'

const OrganisationLogo = ({ shortname, logo_url, className }) => {
  return(
    <React.Fragment>
      <img src={logo_url}
           width='100'
           height='100'
           className={className}
           alt={shortname + '-logo'} />
    </React.Fragment>
  )
}

OrganisationLogo.propTypes = {
  logo_url: PropTypes.string.isRequired,
  shortname: PropTypes.string.isRequired
}

export default OrganisationLogo
